import React from "react";
import { ExpandableRow } from "component-library";

import "./BreakdownExpandableContainer.scss";

interface IBreakdownExpandableContainerProps {
  children: React.ReactElement<ExpandableRow>;
}

const BreakdownExpandableContainer: React.FC<
  React.PropsWithChildren<IBreakdownExpandableContainerProps>
> = (props) => (
  <div className="c-breakdown-expandable-container">{props.children}</div>
);

export default BreakdownExpandableContainer;
